import request from '@/utils/request'


// 查询财务人员列表
export function listCompanyFinance(query) {
  return request({
    url: '/user/company-finance/list',
    method: 'get',
    params: query
  })
}

// 查询财务人员分页
export function pageCompanyFinance(query) {
  return request({
    url: '/user/company-finance/page',
    method: 'get',
    params: query
  })
}

// 查询财务人员详细
export function getCompanyFinance(data) {
  return request({
    url: '/user/company-finance/detail',
    method: 'get',
    params: data
  })
}

// 新增财务人员
export function addCompanyFinance(data) {
  return request({
    url: '/user/company-finance/add',
    method: 'post',
    data: data
  })
}

// 修改财务人员
export function updateCompanyFinance(data) {
  return request({
    url: '/user/company-finance/edit',
    method: 'post',
    data: data
  })
}

// 删除财务人员
export function delCompanyFinance(data) {
  return request({
    url: '/user/company-finance/delete',
    method: 'post',
    data: data
  })
}
